import React from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { refresh } from "ionicons/icons";
import styles from "./HomeParhato2.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

interface VpnErrorStateProps {
  onRetry: () => void;
}

const VpnErrorState: React.FC<VpnErrorStateProps> = ({ onRetry }) => {
  return (
    <div className="w-[98%] top-1/2 absolute left-1 flex gap-4 items-center justify-between text-center px-4 py-2.5 border-1 rounded-3xl bg-orange-200">
      <div className="flex flex-col items-start justify-center">
        <p className="text-sm font-bold">Ошибка соединения с сервером</p>
        <p className="text-xs">Возможно ошибки и долгая загрузка из-за VPN</p>
      </div>
      <IonButton onClick={onRetry} className={cx("retryButton")}>
        <IonIcon icon={refresh} color="white" />
      </IonButton>
    </div>
  );
};

export default VpnErrorState;
